webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_OMD3_OMD3_vue__ = __webpack_require__(70);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    OMD3: __WEBPACK_IMPORTED_MODULE_0__components_pages_OMD3_OMD3_vue__["a" /* default */]
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Viewer_Viewer_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Editor_Editor_vue__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Editor2D_Editor2D_vue__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Editor2D_coder_js__ = __webpack_require__(58);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Viewer: __WEBPACK_IMPORTED_MODULE_1__Viewer_Viewer_vue__["a" /* default */],
    Editor: __WEBPACK_IMPORTED_MODULE_2__Editor_Editor_vue__["a" /* default */],
    Editor2D: __WEBPACK_IMPORTED_MODULE_3__Editor2D_Editor2D_vue__["a" /* default */]
  },
  data: function data() {
    return {
      current: false,
      editWith: 'blockers',
      plotters: [{
        type: 'code',
        id: Math.random() + '',
        color: '#ff0000',
        formula: '\n// mover 3D\n//output global\nvar max = 1024;\n\nvar index = 0;\n// mover3D.reset();\n\nfor (var i = 0; i < max; i++) {\n  mover3D.turnBy(0.0, 13, 0.0);\n  mover3D.moveBy(2.0, 0.07, 0.0);\n}\n',
        stepper: 0.2
      }, {
        type: 'code',
        id: Math.random() + '',
        color: '#ff0000',
        formula: '\n// mover2D\n//output global\nvar max = 2048;\n\nvar index = 0;\n// mover2D.reset();\n\nfor (var i = 0; i < max; i++) {\n  mover2D.turnBy(45.1, \'xy\');\n  mover2D.moveBy(205 * i / max);\n}\n\n',
        stepper: 0.2
      }, {
        type: 'code',
        id: Math.random() + '',
        color: '#ff00ff',
        formula: '\n// Spiral\n//output global\nvar max = 1024;\n\nvar index = 0;\nfor (var i = 0; i < max; i++) {\n  let e = i / max * Math.PI * 2.0;\n\n  var x = (0.5 - Math.sin(e) * Math.sin(e)) * 100.0;\n  var y = (Math.sin(e) * Math.cos(e)) * 100.0;\n  var z = e * 10.0;\n\n  positions[index++] = x;\n  positions[index++] = y;\n  positions[index++] = z;\n}\n',
        stepper: 0.75
      }, {
        type: 'code',
        id: Math.random() + '',
        color: '#bababa',
        formula: '\n// random path\n//output global\nvar max = 1024;\n\nvar x = 0;\nvar y = 0;\nvar z = 0;\nvar index = 0;\nfor (var i = 0; i < max; i++) {\n  positions[index++] = x;\n  positions[index++] = y;\n  positions[index++] = z;\n\n  x += (Math.random() - 0.5) * 8;\n  y += (Math.random() - 0.5) * 8;\n  z += (Math.random() - 0.5) * 8;\n}\n',
        stepper: 0.01
      }, {
        type: 'blockers',
        id: Math.random() + '',
        color: '#000000',
        stepper: 1.0,
        formula: '',
        blockers: __WEBPACK_IMPORTED_MODULE_4__Editor2D_coder_js__["b" /* makeDemo1 */]()
      }]
    };
  },
  mounted: function mounted() {
    this.current = this.plotters.find(function (e) {
      return e.type === 'blockers';
    });
  },

  methods: {
    cloneMe: function cloneMe(item) {
      var newItem = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item));
      newItem.id = Math.random() + '';
      newItem.color = 'hsl(' + Math.floor(Math.random() * 360) + ', 50%, 50%)';
      this.plotters.push(newItem);
    }
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Viewer_vue__ = __webpack_require__(14);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2aff6e16_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Viewer_vue__ = __webpack_require__(189);
function injectStyle (ssrContext) {
  __webpack_require__(74)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2aff6e16"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Viewer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2aff6e16_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Viewer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_three__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_imports_loader_THREE_three_three_examples_js_controls_OrbitControls_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_imports_loader_THREE_three_three_examples_js_controls_OrbitControls_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_imports_loader_THREE_three_three_examples_js_controls_OrbitControls_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ThreeJS_Bundle_js__ = __webpack_require__(104);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable */

/* eslint-enable */


// import simpleVS from '@/components/Shaders/Simple/vs.vert'
// import simpleFS from '@/components/Shaders/Simple/fs.frag'

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    plotters: {},
    noControl: {
      default: false
    }
  },
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_4__components_ThreeJS_Bundle_js__["a" /* default */]),
  computed: {},
  methods: {
    lookAt: function lookAt(lookAtCase) {
      var _this = this;

      if (lookAtCase === 'xy') {
        new __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js__["Tween"](this.camera.position).to({ x: 0, y: 0, z: 200 }, 1200).easing(__WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js__["Easing"].Quadratic.Out).onUpdate(function () {
          _this.camera.lookAt(_this.scene);
        }).start();
      } else if (lookAtCase === 'xz') {
        new __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js__["Tween"](this.camera.position).to({ x: 0, y: 200, z: 0 }, 1200).easing(__WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js__["Easing"].Quadratic.Out).onUpdate(function () {
          _this.camera.lookAt(_this.scene);
        }).start();
      } else if (lookAtCase === 'yz') {
        new __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js__["Tween"](this.camera.position).to({ x: 200, y: 0, z: 0 }, 1200).easing(__WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js__["Easing"].Quadratic.Out).onUpdate(function () {
          _this.camera.lookAt(_this.scene);
        }).start();
      }
    },
    gotToucher: function gotToucher(toucher) {
      var _this2 = this;

      this.toucher = toucher;
      toucher.addEventListener('click', function () {
        _this2.$emit('click');
      });
      this.control = new __WEBPACK_IMPORTED_MODULE_2_three__["OrbitControls"](this.camera, this.toucher);
      this.control.enableKeys = false;
    },
    renderWebGL: function renderWebGL() {
      __WEBPACK_IMPORTED_MODULE_1__tweenjs_tween_js__["update"]();

      this.animatable.time.value = window.performance.now() * 0.001;
      if (this.control) {
        this.control.update();
      }
      if (this.scene && this.camera && this.renderer) {
        this.renderer.render(this.scene, this.camera);
      }
    }
  },
  data: function data() {
    return {
      helper: {
        xy: true,
        yz: true,
        xz: true
      },
      camPos: { x: 0, y: 0, z: 200 },
      PI: Math.PI,
      world: {
        rx: 0,
        ry: 0,
        rz: 0
      },
      THREE: __WEBPACK_IMPORTED_MODULE_2_three__,
      control: false,
      toucher: false,
      animatable: {
        time: { value: 0 }
      },
      size: false,
      renderer: false,
      scene: false,
      camera: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this3 = this;

    var resizer = function resizer() {
      var rect = _this3.$refs['wrapper'].getBoundingClientRect();
      _this3.size = {
        width: rect.width,
        height: rect.height,
        aspect: rect.width / rect.height
      };
      _this3.$nextTick(function () {
        _this3.$refs['renderer'].resize();
      });
    };
    window.addEventListener('resize', resizer, false);
    resizer();

    this.$nextTick(resizer);

    var self = this;
    function loop() {
      self.rAFID = window.requestAnimationFrame(loop);
      self.renderWebGL();
    }
    self.rAFID = window.requestAnimationFrame(loop);
  }
});

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    items: {
      default: function _default() {
        return [];
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    var textureCube = new __WEBPACK_IMPORTED_MODULE_0_three__["CubeTextureLoader"]();
    textureCube.load(this.items, function (textureCube) {
      _this.$parent.$emit('apply-texture', textureCube);
      _this.$emit('cube-texture', textureCube);
    });
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    sceneRenderer: {},
    sceneCamera: {},
    width: { default: window.innerWidth },
    height: { default: window.innerHeight }
  },
  data: function data() {
    return {
      scene: false,
      texture: false,
      mesh: false,
      cube: false,
      material: false
    };
  },
  mounted: function mounted() {
    var cubeScene = this.scene = new __WEBPACK_IMPORTED_MODULE_0_three__["Scene"]();
    this.camera = new __WEBPACK_IMPORTED_MODULE_0_three__["PerspectiveCamera"](60, this.width / this.height, 1, 100000);

    var textureCube = this.texture = new __WEBPACK_IMPORTED_MODULE_0_three__["CubeTexture"]();
    // textureCube.load(
    //   [
    //     require('../textures/cubemap/empty/px.png'), require('../textures/cubemap/empty/nx.png'),
    //     require('../textures/cubemap/empty/py.png'), require('../textures/cubemap/empty/ny.png'),
    //     require('../textures/cubemap/empty/pz.png'), require('../textures/cubemap/empty/nz.png')
    //   ],
    //   () => {
    //   }
    // )
    this.$emit('cube-map-target', this);

    var shader = __WEBPACK_IMPORTED_MODULE_0_three__["ShaderLib"].cube;
    shader.uniforms.tCube.value = textureCube;
    textureCube.mapping = __WEBPACK_IMPORTED_MODULE_0_three__["CubeRefractionMapping"];

    var material = this.material = new __WEBPACK_IMPORTED_MODULE_0_three__["ShaderMaterial"]({
      fragmentShader: shader.fragmentShader,
      vertexShader: shader.vertexShader,
      uniforms: shader.uniforms,
      depthWrite: false,
      side: __WEBPACK_IMPORTED_MODULE_0_three__["BackSide"]
    });

    var mesh = this.cube = this.mesh = new __WEBPACK_IMPORTED_MODULE_0_three__["Mesh"](new __WEBPACK_IMPORTED_MODULE_0_three__["BoxGeometry"](300, 300, 300), material);
    cubeScene.add(mesh);

    this.sceneRenderer.autoClear = false;
  },
  beforeDestroy: function beforeDestroy() {
    this.sceneRenderer.autoClear = true;
  },

  // activated () {
  //   this.sceneRenderer.autoClear = true
  // },
  // deactivated () {
  //   this.sceneRenderer.autoClear = false
  // },
  methods: {
    update: function update() {
      if (this.sceneRenderer && this.scene && this.camera) {
        this.camera.rotation.copy(this.sceneCamera.rotation);
        this.sceneRenderer.render(this.scene, this.camera);
      }
    }
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//

// import * as THREE from 'three'
// /* eslint-disable */
// import 'imports-loader?THREE=three!three/examples/js/controls/TrackBallControls.js'
// /* eslint-enable */

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    camera: {},
    toucher: {}
  },
  data: function data() {
    return {
      controls: false
    };
  },
  mounted: function mounted() {
    // this.controls = new THREE.TrackBallControls(this.camera, this.toucher)
    // this.$emit('controls', this.controls)
  },
  beforeDestroy: function beforeDestroy() {
    // this.controls.dispose()
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_imports_loader_THREE_three_three_examples_js_controls_OrbitControls_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_imports_loader_THREE_three_three_examples_js_controls_OrbitControls_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_imports_loader_THREE_three_three_examples_js_controls_OrbitControls_js__);
//
//
//
//
//
//
//


/* eslint-disable */

/* eslint-enable */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // THREE,
      renderer: false
    };
  },

  props: {
    size: {
      default: function _default() {
        return { width: 500, height: 500 };
      }
    },
    alpha: { default: true },
    antialias: { default: true }
  },
  mounted: function mounted() {
    this.renderer = new __WEBPACK_IMPORTED_MODULE_0_three__["WebGLRenderer"]({
      alpha: this.alpha,
      antialias: this.antialias // ,
      // preserveDrawingBuffer: true
    });

    this.resize();
    this.renderer.domElement.style.marginBottom = '-6px';
    this.renderer.domElement.style['-webkit-tap-highlight-color'] = 'transparent';
    this.$refs.mounter.appendChild(this.renderer.domElement);

    this.$emit('renderer', this.renderer);
    this.$emit('toucher', this.$refs['toucher']);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.mounter.removeChild(this.renderer.domElement);
  },

  watch: {
    size: function size() {
      this.resize();
    }
  },
  methods: {
    resize: function resize() {
      var ratio = window.devicePixelRatio || 1;
      this.renderer.setPixelRatio(ratio);
      this.renderer.setSize(this.size.width, this.size.height);
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      scene: false
    };
  },

  props: {
    size: {
      default: function _default() {
        return { width: 500, height: 500 };
      }
    },
    alpha: { default: true },
    antialias: { default: true }
  },
  created: function created() {
    var _this = this;

    this.scene = new __WEBPACK_IMPORTED_MODULE_0_three__["Scene"]();
    this.$on('add', function (v) {
      _this.scene.add(v);
    });
    this.$on('remove', function (v) {
      _this.scene.remove(v);
    });
  },
  mounted: function mounted() {
    this.$emit('scene', this.scene);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  abstract: true,
  render: function render() {
    return null;
  },

  props: ['fov', 'aspect', 'near', 'far', 'position'],
  data: function data() {
    return {
      camera: null
    };
  },
  created: function created() {
    this.camera = new __WEBPACK_IMPORTED_MODULE_0_three__["PerspectiveCamera"](this.fov, this.aspect, this.near, this.far);

    if (this.position) {
      this.camera.position.x = this.position.x;
      this.camera.position.y = this.position.y;
      this.camera.position.z = this.position.z;
    }
    this.$emit('camera', this.camera);
  },

  watch: {
    position: function position() {
      if (this.position) {
        this.camera.position.x = this.position.x;
        this.camera.position.y = this.position.y;
        this.camera.position.z = this.position.z;
      }
    },
    aspect: function aspect() {
      if (this.camera) {
        this.camera.aspect = this.aspect;
        this.camera.updateProjectionMatrix();
      }
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    near: {},
    far: {},
    resolution: {},
    renderer: {},
    scene: {}
  },
  data: function data() {
    return {
      camera: false,
      remove: function remove() {}
    };
  },
  created: function created() {
    var _this = this;

    var camera = this.camera = new __WEBPACK_IMPORTED_MODULE_0_three__["CubeCamera"](this.near, this.far, this.resolution);

    this.$emit('cube-camera', camera);
    this.$parent.$emit('add', camera);
    this.remove = function () {
      _this.$parent.$emit('remove', camera);
    };
  },
  beforeDestroy: function beforeDestroy() {
    this.remove();
  },

  methods: {},
  watch: {}
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
//
//
//
//

// import * as TWEEN from '@tweenjs/tween.js'


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      mdown: 0,
      rAFID: 0,
      mouse: null,
      raycast: function raycast() {},
      clean: function clean() {}
    };
  },

  props: {
    scene: {},
    camera: {},
    toucher: {}
  },
  watch: {
    toucher: function toucher() {
      this.setupToucher();
    }
  },
  created: function created() {
    var _this = this;

    var raycaster = new __WEBPACK_IMPORTED_MODULE_0_three__["Raycaster"]();
    this.mouse = new __WEBPACK_IMPORTED_MODULE_0_three__["Vector2"]();

    this.setupToucher = function () {
      _this.clean();
      _this.toucher.addEventListener('mousedown', _this.handleDown, false);
      _this.toucher.addEventListener('click', _this.handleClick, false);
      _this.toucher.addEventListener('mousemove', _this.handleMV, false);
      _this.toucher.style['-webkit-tap-highlight-color'] = 'rgba(0,0,0,0)';

      console.log(_this.toucher);
      _this.clean = function () {
        _this.toucher.removeEventListener('mousedown', _this.handleDown);
        _this.toucher.removeEventListener('click', _this.handleClick);
        _this.toucher.removeEventListener('mousemove', _this.handleMV);
      };
    };

    var raycast = function raycast() {
      var mouse = _this.mouse;
      var scene = _this.scene;
      var camera = _this.camera;

      var restore = [];
      _this.scene.traverse(function (ele) {
        if (ele.$skipRayCast) {
          restore.push({
            parent: ele.parent,
            ele: ele
          });
          ele.parent.remove(ele);
        }
      });

      // update the picking ray with the camera and mouse position
      raycaster.setFromCamera(mouse, camera);
      // calculate objects intersecting the picking ray
      var intersects = raycaster.intersectObjects(scene.children, true);

      restore.forEach(function (item) {
        item.parent.add(item.ele);
      });

      return intersects;
    };
    this.raycast = raycast;
  },
  mounted: function mounted() {
    this.setupToucher();
  },

  // activated () {
  //   this.setupToucher()
  //   // var rAF = () => {
  //   //   this.rAFID = window.requestAnimationFrame(rAF)
  //   //   // this.raycast()
  //   // }
  //   // this.rAFID = window.requestAnimationFrame(rAF)
  // },
  // deactivated () {
  //   this.setupToucher()
  //   // this.setupToucher()
  //   // window.cancelAnimationFrame(this.rAFID)
  //   // this.clean()
  // },
  beforeDestroy: function beforeDestroy() {
    this.setupToucher();
  },

  methods: {
    handleDown: function handleDown(event) {
      // console.log(event)
      this.mdown = event.timeStamp;
    },
    handleClick: function handleClick(event) {
      var diff = event.timeStamp - this.mdown;
      if (diff < 350) {
        var intersects = this.raycast();

        var inter = intersects[0];
        if (inter && inter.object && inter.object.onClick) {
          inter.object.onClick({
            object: inter.object,
            intersection: inter,
            event: event,
            intersects: intersects
          });
        }
      }
    },
    handleMV: function handleMV(event) {
      this.mouse.x = event.clientX / window.innerWidth * 2 - 1;
      this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
    }
  }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    x: {
      default: 1
    },
    y: {
      default: 0
    },
    z: {
      default: 0
    },
    colorAxis: {
      default: 0x111111
    },
    colorGrid: {
      default: 0xbababa
    }
  },
  methods: {
    setup: function setup() {
      var _this = this;

      if (this.clean) {
        this.clean();
      }
      var helper = new __WEBPACK_IMPORTED_MODULE_0_three__["GridHelper"](200, 10, new __WEBPACK_IMPORTED_MODULE_0_three__["Color"](this.colorAxis), new __WEBPACK_IMPORTED_MODULE_0_three__["Color"](this.colorGrid));
      this.$parent.$emit('add', helper);
      this.clean = function () {
        _this.$parent.$emit('remove', helper);
      };
    }
  },
  mounted: function mounted() {
    this.setup();
  },

  watch: {
    colorAxis: function colorAxis() {
      this.setup();
    },
    colorGrid: function colorGrid() {
      this.setup();
    }
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      object3d: false
    };
  },

  props: {
    visible: { default: true },
    px: { default: 0 },
    py: { default: 0 },
    pz: { default: 0 },

    sx: { default: 1 },
    sy: { default: 1 },
    sz: { default: 1 },

    rx: { default: 0 },
    ry: { default: 0 },
    rz: { default: 0 }
  },
  watch: {
    visible: function visible() {
      this.object3d.setVisible(this.visible);
    },
    px: function px() {
      this.updatePosition('x', this.px);
    },
    py: function py() {
      this.updatePosition('y', this.py);
    },
    pz: function pz() {
      this.updatePosition('z', this.pz);
    },
    sx: function sx() {
      this.updateScale('x', this.sx);
    },
    sy: function sy() {
      this.updateScale('y', this.sy);
    },
    sz: function sz() {
      this.updateScale('z', this.sz);
    },
    rx: function rx() {
      this.updateRotation('x', this.rx);
    },
    ry: function ry() {
      this.updateRotation('y', this.ry);
    },
    rz: function rz() {
      this.updateRotation('z', this.rz);
    }
  },
  created: function created() {
    var _this = this;

    this.object3d = new __WEBPACK_IMPORTED_MODULE_0_three__["Object3D"]();
    this.$emit('element', this.object3d);
    this.object3d.visible = true;
    this.updatePosition();
    this.updateScale();
    this.updateRotation();
    this.$on('add', function (v) {
      _this.object3d.add(v);
    });
    this.$on('remove', function (v) {
      _this.object3d.remove(v);
    });
  },
  mounted: function mounted() {
    this.$emit('attach', this.object3d);
    this.$parent.$emit('add', this.object3d);
  },
  beforeDestroy: function beforeDestroy() {
    this.$emit('detach', this.object3d);
    this.$parent.$emit('remove', this.object3d);
  },

  methods: {
    updatePosition: function updatePosition(key, val) {
      if (key) {
        this.object3d.position[key] = val;
      } else {
        this.object3d.position.set(this.px, this.py, this.pz);
      }
    },
    updateScale: function updateScale(key, val) {
      if (key) {
        this.object3d.scale[key] = val;
      } else {
        this.object3d.scale.set(this.sx, this.sy, this.sz);
      }
    },
    updateRotation: function updateRotation(key, val) {
      if (key) {
        this.object3d.rotation[key] = val;
      } else {
        this.object3d.rotation.set(this.rx, this.ry, this.rz);
      }
    }
  }
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    position: {}
  },
  data: function data() {
    return {
      element: false,
      line: false,
      material: false,
      geometry: false
    };
  },
  created: function created() {
    var _this = this;

    this.element = this.line = new __WEBPACK_IMPORTED_MODULE_0_three__["Line"]();
    this.$parent.$emit('add', this.line);
    this.$emit('element', this.element);

    this.$on('material', function (v) {
      _this.material = v;
      _this.tryUpdateMaterial();
    });
    this.$on('geometry', function (v) {
      // var wireframe = new THREE.WireframeGeometry(v)
      _this.geometry = v;
      _this.tryUpdateGeometry();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.uninstall();
  },

  methods: {
    tryUpdateGeometry: function tryUpdateGeometry(v) {
      if (this.line) {
        this.line.geometry = this.geometry;
      }
    },
    tryUpdateMaterial: function tryUpdateMaterial(v) {
      if (this.line) {
        this.line.material = this.material;
      }
    },
    uninstall: function uninstall() {
      this.$parent.$emit('remove', this.line);
    }
  }
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    position: {}
  },
  data: function data() {
    return {
      element: false,
      lineSegments: false,
      material: false,
      geometry: false
    };
  },
  created: function created() {
    var _this = this;

    this.element = this.lineSegments = new __WEBPACK_IMPORTED_MODULE_0_three__["LineSegments"]();
    this.$parent.$emit('add', this.lineSegments);
    this.$emit('element', this.element);

    this.$on('material', function (v) {
      _this.material = v;
      _this.tryUpdateMaterial();
    });
    this.$on('geometry', function (v) {
      // var wireframe = new THREE.WireframeGeometry(v)
      _this.geometry = v;
      _this.tryUpdateGeometry();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.uninstall();
  },

  methods: {
    tryUpdateGeometry: function tryUpdateGeometry(v) {
      if (this.lineSegments) {
        this.lineSegments.geometry = this.geometry;
      }
    },
    tryUpdateMaterial: function tryUpdateMaterial(v) {
      if (this.lineSegments) {
        this.lineSegments.material = this.material;
      }
    },
    uninstall: function uninstall() {
      this.$parent.$emit('remove', this.lineSegments);
    }
  }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {},
  data: function data() {
    return {
      element: false,
      mesh: false,
      material: false,
      geometry: false
    };
  },
  created: function created() {
    var _this = this;

    this.element = this.mesh = new __WEBPACK_IMPORTED_MODULE_0_three__["Mesh"]();
    this.$parent.$emit('add', this.mesh);
    this.$emit('attach', this.mesh);
    this.$emit('element', this.mesh);

    this.$on('material', function (v) {
      _this.material = v;
      _this.tryUpdateMaterial();
    });
    this.$on('geometry', function (v) {
      _this.geometry = v;
      _this.tryUpdateGeometry();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.uninstall();
  },

  methods: {
    tryUpdateGeometry: function tryUpdateGeometry(v) {
      if (this.mesh) {
        this.mesh.geometry = this.geometry;
      }
    },
    tryUpdateMaterial: function tryUpdateMaterial(v) {
      if (this.mesh) {
        this.mesh.material = this.material;
      }
    },
    uninstall: function uninstall() {
      this.$emit('detach', this.mesh);
      this.$parent.$emit('remove', this.mesh);
    }
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    position: {}
  },
  data: function data() {
    return {
      element: false,
      points: false,
      material: false,
      geometry: false
    };
  },
  created: function created() {
    var _this = this;

    this.element = this.points = new __WEBPACK_IMPORTED_MODULE_0_three__["Points"]();
    this.$parent.$emit('add', this.points);
    this.$emit('element', this.points);
    this.$emit('attach', this.points);
    this.$on('material', function (v) {
      _this.material = v;
      _this.tryUpdateMaterial();
    });
    this.$on('geometry', function (v) {
      _this.geometry = v;
      _this.tryUpdateGeometry();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.uninstall();
  },

  methods: {
    tryUpdateGeometry: function tryUpdateGeometry(v) {
      if (this.points) {
        this.points.geometry = this.geometry;
      }
    },
    tryUpdateMaterial: function tryUpdateMaterial(v) {
      if (this.points) {
        this.points.material = this.material;
      }
    },
    uninstall: function uninstall() {
      this.$emit('detach', this.points);
      this.$parent.$emit('remove', this.points);
    }
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      light: false
    };
  },
  mounted: function mounted() {
    this.light = new __WEBPACK_IMPORTED_MODULE_0_three__["PointLight"]({ color: 0xffffff });
    this.$parent.$emit('add', this.light);
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.$emit('remove', this.light);
  }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      light: false
    };
  },
  mounted: function mounted() {
    this.light = new __WEBPACK_IMPORTED_MODULE_0_three__["SpotLight"]({ color: 0xffffff });
    this.$parent.$emit('add', this.light.target);
    // if (this.$parent.object3d) {
    //   this.light.target = this.$parent.object3d
    // }
    this.$emit('element', this.light);
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.$emit('remove', this.light);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: {
      default: function _default() {
        return Math.random() * 0xffffff;
      }
    }
  },
  data: function data() {
    return {
      material: false
    };
  },
  created: function created() {
    this.material = new __WEBPACK_IMPORTED_MODULE_0_three__["MeshLambertMaterial"]({
      color: this.color
    });
    this.$parent.$emit('material', this.material);
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: {
      default: function _default() {
        return Math.random() * 0xffffff;
      }
    }
  },
  data: function data() {
    return {
      material: false
    };
  },
  created: function created() {
    this.material = new __WEBPACK_IMPORTED_MODULE_0_three__["MeshPhongMaterial"]({
      color: new __WEBPACK_IMPORTED_MODULE_0_three__["Color"](this.color)
    });
    this.$parent.$emit('material', this.material);
  }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: {
      default: function _default() {
        return Math.random() * 0xffffff;
      }
    }
  },
  data: function data() {
    return {
      material: false
    };
  },

  watch: {
    color: function color() {
      this.setup();
    }
  },
  methods: {
    setup: function setup() {
      this.material = new __WEBPACK_IMPORTED_MODULE_0_three__["LineBasicMaterial"]({
        color: new __WEBPACK_IMPORTED_MODULE_0_three__["Color"](this.color),
        linewidth: 0.25
      });
      this.$parent.$emit('material', this.material);
    }
  },
  mounted: function mounted() {
    this.setup();
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      material: false
    };
  },

  props: {
    transparent: {
      default: false
    },
    vs: {
      default: 'void main ( void ) {\n  vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );\n  vec4 outputPos = projectionMatrix * mvPosition;\n  gl_Position = outputPos;\n}'
    },
    fs: {
      default: 'void main () {\n  gl_FragColor = vec4(vec3(0.5), 1.0);\n}'
    },
    uniforms: {
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    transparent: function transparent() {
      this.initShader();
    },
    vs: function vs() {
      this.initShader();
    },
    fs: function fs() {
      this.initShader();
    },
    uniforms: function uniforms() {
      this.initShader();
    }
  },
  mounted: function mounted() {
    this.initShader();
  },

  methods: {
    initShader: function initShader() {
      try {
        this.material = new __WEBPACK_IMPORTED_MODULE_0_three__["ShaderMaterial"]({
          transparent: this.transparent,
          uniforms: this.uniforms,
          vertexShader: this.vs || this.$options.props.vs.default,
          fragmentShader: this.fs || this.$options.props.fs.default
        });
        this.$parent.$emit('material', this.material);
      } catch (e) {
        console.log(e);
      }
    }
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    opacity: {
      default: 1
    },
    color: {
      default: function _default() {
        return new __WEBPACK_IMPORTED_MODULE_0_three__["Color"](Math.random() * 0xffffff);
      }
    }
  },
  watch: {
    opacity: function opacity() {
      this.material.opacity = this.opacity;
    }
  },
  data: function data() {
    return {
      material: false
    };
  },
  mounted: function mounted() {
    this.material = new __WEBPACK_IMPORTED_MODULE_0_three__["MeshBasicMaterial"]({ color: this.color, transparent: true, opacity: this.opacity });
    this.$parent.$emit('material', this.material);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    sizeAttenuation: {
      default: true
    },
    size: {
      default: 1.0
    },
    color: {
      default: function _default() {
        return new __WEBPACK_IMPORTED_MODULE_0_three__["Color"](Math.random() * 0xffffff);
      }
    }
  },
  data: function data() {
    return {
      material: false
    };
  },
  mounted: function mounted() {
    this.material = new __WEBPACK_IMPORTED_MODULE_0_three__["PointsMaterial"]({ color: new __WEBPACK_IMPORTED_MODULE_0_three__["Color"](this.color), size: this.size });
    this.$parent.$emit('material', this.material);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GeoWorker_worker_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GeoWorker_worker_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__GeoWorker_worker_js__);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    step: {
      default: 0
    },
    formula: {
      required: true
    }
  },
  data: function data() {
    return {
      iFrameURL: '',
      updateDrawRage: function updateDrawRage() {},

      worker: false,
      Worker: __WEBPACK_IMPORTED_MODULE_1__GeoWorker_worker_js___default.a,
      maxPoints: 0,
      drawCount: 0,
      geometry: false
    };
  },

  watch: {
    step: function step() {
      this.updateDrawRage();
    },
    formula: function formula() {
      this.setupWorker();
    }
  },
  mounted: function mounted() {
    this.$parent.$emit('geometry', new __WEBPACK_IMPORTED_MODULE_0_three__["BoxBufferGeometry"](0.01, 0.01, 0.01, 1, 1, 1));
    this.setupWorker();
  },

  methods: {
    setupWorker: function setupWorker() {
      var _this = this;

      if (this.worker) {
        this.worker.terminate();
      }
      this.worker = new __WEBPACK_IMPORTED_MODULE_1__GeoWorker_worker_js___default.a();
      setTimeout(function () {
        _this.worker.terminate();
      }, 1000 * 120);

      this.worker.postMessage({ formula: this.formula });
      this.worker.addEventListener('message', function (evt) {
        // console.log(evt.data)
        var positions = evt.data.positions;

        _this.maxPoints = positions.length / 3;
        var geometry = new __WEBPACK_IMPORTED_MODULE_0_three__["BufferGeometry"]();

        // attributes
        geometry.addAttribute('position', new __WEBPACK_IMPORTED_MODULE_0_three__["Float32BufferAttribute"](positions, 3));

        geometry.attributes.position.needsUpdate = true;

        _this.updateDrawRage = function () {
          _this.drawCount = Math.floor(_this.step * _this.maxPoints);
          geometry.setDrawRange(0, _this.drawCount);
        };
        _this.updateDrawRage();

        _this.$parent.$emit('geometry', geometry);
      });
    }
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    n: {
      default: 32
    },
    r: {
      default: 2
    }
  },
  data: function data() {
    return {
      geometry: false
    };
  },

  watch: {
    n: function n() {
      var geometry = new __WEBPACK_IMPORTED_MODULE_0_three__["CircleBufferGeometry"](this.r, this.n);
      this.$parent.$emit('geometry', geometry);
    }
  },
  mounted: function mounted() {
    // n = segments
    // r = radius
    var geometry = new __WEBPACK_IMPORTED_MODULE_0_three__["CircleBufferGeometry"](this.r, this.n);
    this.$parent.$emit('geometry', geometry);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    radius: { default: 1.3 },
    tube: { default: 0.13 },
    tubularSegments: { default: 300 },
    radialSegments: { default: 20 },
    p: { default: 4 },
    q: { default: 3 }
  },
  data: function data() {
    return {
      geometry: false
    };
  },
  mounted: function mounted() {
    var radius = this.radius,
        tube = this.tube,
        tubularSegments = this.tubularSegments,
        radialSegments = this.radialSegments,
        p = this.p,
        q = this.q;

    var geometry = new __WEBPACK_IMPORTED_MODULE_0_three__["TorusKnotBufferGeometry"](radius, tube, tubularSegments, radialSegments, p, q);
    this.$parent.$emit('geometry', geometry);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    nx: {
      default: 5
    },
    ny: {
      default: 5
    },
    r: {
      default: 2
    }
  },
  data: function data() {
    return {
      geometry: false
    };
  },
  mounted: function mounted() {
    var geometry = new __WEBPACK_IMPORTED_MODULE_0_three__["SphereBufferGeometry"](this.r, this.nx, this.ny);
    this.$parent.$emit('geometry', geometry);
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      geometry: false
    };
  },
  mounted: function mounted() {
    var geometry = new __WEBPACK_IMPORTED_MODULE_0_three__["BoxBufferGeometry"](2, 2, 2, 12, 12, 12);
    this.$parent.$emit('geometry', geometry);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_three__ = __webpack_require__(1);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    width: {
      default: 5
    },
    height: {
      default: 5
    },
    nx: {
      default: 30
    },
    ny: {
      default: 30
    }
  },
  data: function data() {
    return {
      geometry: false
    };
  },

  watch: {
    width: function width() {
      this.makeGeometry();
    },
    height: function height() {
      this.makeGeometry();
    },
    nx: function nx() {
      this.makeGeometry();
    },
    ny: function ny() {
      this.makeGeometry();
    }
  },
  methods: {
    makeGeometry: function makeGeometry() {
      var geometry = new __WEBPACK_IMPORTED_MODULE_0_three__["PlaneBufferGeometry"](this.width, this.height, this.nx, this.ny);
      this.$parent.$emit('geometry', geometry);
    }
  },
  mounted: function mounted() {
    this.makeGeometry();
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_ACE_ACE_vue__ = __webpack_require__(192);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    current: {},
    plotters: {}
  },
  components: {
    ACE: __WEBPACK_IMPORTED_MODULE_0__components_shared_ACE_ACE_vue__["a" /* default */]
  },
  methods: {
    cloneThis: function cloneThis(item) {
      this.$emit('clone', item);
      // var newItem = JSON.parse(JSON.stringify(item))
      // newItem.id = Math.random() + ''
      // newItem.color = `hsl(${Math.floor(Math.random() * 360)}, 50%, 50%)`
      // this.plotters.push(newItem)
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

var ace = __webpack_require__(194);
// npm install --save vue2-ace-editor

// require(['emmet/emmet'], function (data) {
//   window.emmet = data.emmet
// })

/*
<ACE
  v-if="currentFile"
  @save="() => {}"
  :path="currentFile.path"
  v-model="currentFile.src"
  @input="() => { isDirty = true; }"
  theme="chrome"
  width="100%"
  :height="'1024'"
>
</ACE>
*/

/* harmony default export */ __webpack_exports__["a"] = ({
  template: '',
  props: {
    value: {},
    filepath: {
      type: String,
      default: 'lol.js'
    },
    theme: String,
    height: true,
    width: true
  },
  data: function data() {
    return {
      editor: null,
      contentBackup: ''
    };
  },

  methods: {
    px: function px(n) {
      if (/^\d*$/.test(n)) {
        return n + 'px';
      }
      return n;
    },
    getLangFromPath: function getLangFromPath(path) {
      var ans = 'html';
      try {
        var ext = path.split('.').pop();

        if (ext === 'js') {
          ans = 'javascript';
        }
        if (ext === 'vue') {
          ans = 'html';
        }
        if (ext === 'html') {
          ans = 'html';
        }
        if (ext === 'css') {
          ans = 'css';
        }
        if (ext === 'vert') {
          ans = 'glsl';
        }
        if (ext === 'frag') {
          ans = 'glsl';
        }
      } catch (e) {
        console.log(e);
      }

      return ans;
    },
    setup: function setup() {
      var _this = this;

      var vm = this;
      var theme = this.theme || 'chrome';

      // require('brace/ext/emmet')

      var editor = vm.editor = ace.edit(this.$el);

      var commands = [{
        name: 'open-files',
        bindKey: { win: 'Ctrl-O', mac: 'Command-O' },
        exec: function exec(editor) {
          // var val = editor.getValue()
          _this.$emit('open');
        },
        readOnly: true // false if this command should not apply in readOnly mode
      }, {
        name: 'save',
        bindKey: { win: 'Ctrl-S', mac: 'Command-S' },
        exec: function exec(editor) {
          var val = editor.getValue();
          _this.$emit('save', val);
        },
        readOnly: true // false if this command should not apply in readOnly mode
      }, {
        name: 'multicursor',
        bindKey: { win: 'Ctrl-D', mac: 'Command-D' },
        exec: function exec(editor) {
          editor.selectMore(1);
        },
        // multiSelectAction: 'forEach',
        scrollIntoView: 'cursor',
        readOnly: true // false if this command should not apply in readOnly mode
      }];
      if (Array.isArray(commands)) {
        commands.forEach(function (command) {
          vm.editor.commands.addCommand(command);
        });
      }

      // this.$emit('init', editor)

      __webpack_require__(195);
      __webpack_require__(197);
      __webpack_require__(198);
      __webpack_require__(199);
      // require('brace/mode/sass')
      __webpack_require__(200);
      __webpack_require__(201);

      editor.$blockScrolling = Infinity;
      // editor.setOption('enableEmmet', true)
      editor.getSession().setMode('ace/mode/' + this.getLangFromPath(this.filepath));
      editor.setTheme('ace/theme/' + theme);
      editor.session.setValue(this.value, 1);
      editor.session.setOptions({ tabSize: 2, useSoftTabs: true });
      editor.setOptions({ fontSize: '16px' });
      editor.session.setOption('useWorker', false);

      editor.on('change', function () {
        var content = editor.getValue();
        vm.$emit('input', content);
        vm.contentBackup = content;
      });
    }
  },
  watch: {
    value: function value(val) {
      if (this.contentBackup !== val) {
        this.editor.setValue(val, 1);
      }
    },
    filepath: function filepath() {
      this.editor.getSession().setMode('ace/mode/' + this.getLangFromPath(this.filepath));
    }
  },
  mounted: function mounted() {
    this.setup();
  }
});

/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LoopItem_vue__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__coder_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Viewer_Viewer_vue__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var rID = function rID() {
  return '_' + Math.random().toString(36).substr(2, 9);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default.a,
    LoopItem: __WEBPACK_IMPORTED_MODULE_1__LoopItem_vue__["a" /* default */],
    Viewer: __WEBPACK_IMPORTED_MODULE_3__Viewer_Viewer_vue__["a" /* default */]
  },
  props: {
    current: {}
  },
  data: function data() {
    return {
      console: console,
      JSON: JSON,
      rID: rID,
      coder: __WEBPACK_IMPORTED_MODULE_2__coder_js__["a" /* make */](),
      tools: __WEBPACK_IMPORTED_MODULE_2__coder_js__["c" /* makeTools */]()
    };
  },
  mounted: function mounted() {
    this.current.formula = this.formula;
  },

  watch: {
    formula: function formula() {
      this.current.formula = this.formula;
    }
  },
  computed: {
    formula: function formula() {
      return this.coder.getCode(this.current.blockers.tree, this.current.blockers.tree.id);
    }
  },
  methods: {}
});

/***/ }),
/* 56 */,
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var rID = function rID() {
  return '_' + Math.random().toString(36).substr(2, 9);
};

var output = {
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a
  },
  props: {
    mode: {},
    model: Object
  },
  beforeCreate: function beforeCreate() {
    this.$options.components.LoopItem = output;
  },
  data: function data() {
    return {
      console: console,
      open: false
    };
  },

  computed: {
    isFolder: function isFolder() {
      return this.model.children;
    }
  },
  methods: {
    cloner: function cloner(el) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, el, {
        pull: true,
        put: true,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, el.data),
        id: rID()
      });
    },
    remvoePlaceHolder: function remvoePlaceHolder() {
      var _this = this;

      if (this.$parent) {
        var idx = this.$parent.model.children.findIndex(function (pc) {
          return pc.id === _this.model.id;
        });
        this.$parent.model.children.splice(idx, 1);
      }
    },
    toggle: function toggle() {
      if (this.isFolder) {
        this.open = !this.open;
      }
    },
    changeType: function changeType() {
      if (!this.isFolder) {
        this.$set(this.model, 'children', []);
        this.addChild();
        this.open = true;
      }
    },
    addChild: function addChild() {
      this.model.children.unshift({
        id: rID(),
        put: true,
        pull: true,
        type: 'comment',
        data: {
          comment: '// please type some note'
        }
      });
    },
    emptyTrash: function emptyTrash() {
      this.model.children = [];
    }
  },
  mounted: function mounted() {
    this.$emit('ready', {
      model: this.model
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = (output);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return makeTools; });
/* unused harmony export makeTemplate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return makeDemo1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return make; });
var rID = function rID() {
  return '_' + Math.random().toString(36).substr(2, 9);
};

var makeTools = function makeTools() {
  return {
    type: 'tools',
    put: false,
    pull: 'clone',
    children: [{
      id: rID(),
      put: true,
      pull: true,
      type: 'variable',
      data: {
        name: 'angleInc',
        init: '0'
      }
    }, {
      id: rID(),
      put: true,
      pull: true,
      type: 'update',
      data: {
        name: 'angleInc',
        modification: 'add-by',
        value: '0.1'
      }
    }, {
      id: rID(),
      put: true,
      pull: true,
      type: 'mover2D.usePlane',
      data: {
        usePlane: 'xy'
      }
    }, {
      id: rID(),
      put: true,
      pull: true,
      type: 'mover2D.moveBy',
      data: {
        amount: 1
      }
    }, {
      id: rID(),
      put: true,
      pull: true,
      type: 'mover2D.turnBy',
      data: {
        amount: 1
      }
    }, {
      id: rID(),
      put: false,
      pull: false,
      type: 'repeat',
      data: {
        times: 5
      },
      children: [{
        id: rID(),
        put: false,
        pull: false,
        type: 'mover2D.moveBy',
        data: {
          amount: 1
        }
      }]
    }]
  };
};

var makeTemplate = function makeTemplate() {
  return {
    tree: {
      type: 'program entry point',
      children: []
    }
  };
};

var makeDemo1 = function makeDemo1() {
  return {
    bin: {
      type: 'recycle bin',
      children: []
    },
    tree: {
      type: 'program entry point',
      children: [{
        id: rID(),
        put: true,
        pull: true,
        type: 'variable',
        data: {
          name: 'angleInc',
          init: '0'
        }
      }, {
        id: rID(),
        put: true,
        pull: true,
        type: 'repeat',
        data: {
          times: 500
        },
        children: [{
          id: rID(),
          put: true,
          pull: true,
          type: 'update',
          data: {
            name: 'angleInc',
            modification: 'add-by',
            value: '0.1'
          }
        }, {
          id: rID(),
          put: true,
          pull: true,
          type: 'mover2D.turnBy',
          data: {
            amount: 'angleInc'
          }
        }, {
          id: rID(),
          put: true,
          pull: true,
          type: 'mover2D.moveBy',
          data: {
            amount: 1
          }
        }]
      }]
    }
  };
};

var make = function make() {
  var state = {
    nest: {}
  };
  var api = {
    state: state,

    getVariableMod: function getVariableMod(child, id) {
      var indent = state.nest[id];

      var operand = '=';
      var mod = child.data.modification;
      if (mod === 'add-by') {
        operand = '+=';
      }
      if (mod === 'subtract-by') {
        operand = '-=';
      }
      if (mod === 'multiply-by') {
        operand = '*=';
      }
      if (mod === 'divided-by') {
        operand = '/=';
      }

      if (mod === 'set-to') {
        operand = '=';
      }

      var str = indent + (child.data.name + ' ' + operand + ' ' + child.data.value + ';');
      str += '\n';

      return str;
    },
    getVariableInit: function getVariableInit(child, id) {
      var indent = state.nest[id];

      var str = indent + ('var ' + child.data.name + ' = ' + child.data.init + ';');
      str += '\n';

      return str;
    },
    getMoverUsePlane: function getMoverUsePlane(child, id) {
      var indent = state.nest[id];

      var str = indent + ('mover2D.usePlane(\'' + child.data.usePlane + '\');');
      str += '\n';

      return str;
    },
    getMoverTurnBy: function getMoverTurnBy(child, id) {
      var indent = state.nest[id];

      var str = indent + ('mover2D.turnBy(' + child.data.amount + ');');
      str += '\n';

      return str;
    },
    getMoverMove: function getMoverMove(child, id) {
      var indent = state.nest[id];

      var str = indent + ('mover2D.moveBy(' + child.data.amount + ');');
      str += '\n';

      return str;
    },
    getRepeat: function getRepeat(child, id) {
      var indent = state.nest[id];

      var str = indent + 'var n_' + child.id + ' = ' + child.data.times + '; \n';
      str += indent + ('for (let i = 0; i < n_' + child.id + '; i++) {');

      str += indent + '\n';

      str += this.getCode(child, id);

      str += indent + '\n';

      str += indent + '}\n';
      return str;
    },
    getCode: function getCode(child, id) {
      var _this = this;

      state.nest[id] = state.nest[id] || '';
      var str = child.children.reduce(function (accu, item, key) {
        state.nest[id] += '\t';

        if (item.type === 'repeat') {
          accu += _this.getRepeat(item, id);
        }
        if (item.type === 'mover2D.moveBy') {
          accu += _this.getMoverMove(item, id);
        }
        if (item.type === 'mover2D.turnBy') {
          accu += _this.getMoverTurnBy(item, id);
        }
        if (item.type === 'mover2D.usePlane') {
          accu += _this.getMoverUsePlane(item, id);
        }
        if (item.type === 'variable') {
          accu += _this.getVariableInit(item, id);
        }
        if (item.type === 'update') {
          accu += _this.getVariableMod(item, id);
        }

        state.nest[id] = state.nest[id].replace('\t', '');
        return accu;
      }, '');

      console.log(str);
      return str;
    }
  };

  return api;
};

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(66);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a252a5e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(65);
function injectStyle (ssrContext) {
  __webpack_require__(63)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a252a5e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 63 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 64 */,
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(68);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello__["a" /* default */]
  }]
}));

/***/ }),
/* 67 */,
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0782d5fe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__(212);
function injectStyle (ssrContext) {
  __webpack_require__(69)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0782d5fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0782d5fe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OMD3_vue__ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_356b8ab0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OMD3_vue__ = __webpack_require__(211);
function injectStyle (ssrContext) {
  __webpack_require__(71)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-356b8ab0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OMD3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_356b8ab0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OMD3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  CubeTexture: __webpack_require__(105).default,
  CubeMapTarget: __webpack_require__(108).default,
  TrackBallControls: __webpack_require__(111).default,
  Renderer: __webpack_require__(114).default,
  Scene: __webpack_require__(117).default,
  PerspectiveCamera: __webpack_require__(120).default,
  CubeCamera: __webpack_require__(122).default,
  // Refractor: require('./System/Refractor.vue').default,
  Raycaster: __webpack_require__(125).default,

  PlaneHelper: __webpack_require__(128).default,

  Object3D: __webpack_require__(131).default,
  LineStrip: __webpack_require__(134).default,
  LineSegments: __webpack_require__(137).default,
  Mesh: __webpack_require__(140).default,
  Points: __webpack_require__(143).default,
  PointLight: __webpack_require__(146).default,
  SpotLight: __webpack_require__(149).default,

  MeshLambertMaterial: __webpack_require__(152).default,
  MeshPhongMaterial: __webpack_require__(155).default,
  LineBasicMaterial: __webpack_require__(158).default,
  ShaderMaterial: __webpack_require__(161).default,
  MeshBasicMaterial: __webpack_require__(164).default,
  PointsMaterial: __webpack_require__(167).default,

  DrawCountBufferGeometry: __webpack_require__(170).default,
  CircleBufferGeometry: __webpack_require__(174).default,
  TorusKnotBufferGeometry: __webpack_require__(177).default,
  SphereBufferGeometry: __webpack_require__(180).default,
  BoxBufferGeometry: __webpack_require__(183).default,
  PlaneBufferGeometry: __webpack_require__(186).default,

  dummy: {}
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CubeTexture_vue__ = __webpack_require__(22);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4080e36_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CubeTexture_vue__ = __webpack_require__(107);
function injectStyle (ssrContext) {
  __webpack_require__(106)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CubeTexture_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4080e36_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CubeTexture_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cube-texture"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CubeMapTarget_vue__ = __webpack_require__(23);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b70f3d7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CubeMapTarget_vue__ = __webpack_require__(110);
function injectStyle (ssrContext) {
  __webpack_require__(109)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CubeMapTarget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b70f3d7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CubeMapTarget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackBallControls_vue__ = __webpack_require__(24);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bf9a776_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackBallControls_vue__ = __webpack_require__(113);
function injectStyle (ssrContext) {
  __webpack_require__(112)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackBallControls_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bf9a776_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackBallControls_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Renderer_vue__ = __webpack_require__(25);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31f5f518_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Renderer_vue__ = __webpack_require__(116);
function injectStyle (ssrContext) {
  __webpack_require__(115)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31f5f518"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Renderer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31f5f518_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Renderer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full pos-rel"},[_c('div',{ref:"mounter",staticClass:"full layer"}),_vm._v(" "),_c('div',{ref:"toucher",staticClass:"full layer"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scene_vue__ = __webpack_require__(26);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a5fadc9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scene_vue__ = __webpack_require__(119);
function injectStyle (ssrContext) {
  __webpack_require__(118)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a5fadc9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scene_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a5fadc9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scene_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"mounter",staticClass:"mounter"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerspectiveCamera_vue__ = __webpack_require__(27);
/* empty harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(121)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72affb33"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerspectiveCamera_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CubeCamera_vue__ = __webpack_require__(28);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5511892b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CubeCamera_vue__ = __webpack_require__(124);
function injectStyle (ssrContext) {
  __webpack_require__(123)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5511892b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CubeCamera_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5511892b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CubeCamera_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cube-camera"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Raycaster_vue__ = __webpack_require__(29);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57860ca8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Raycaster_vue__ = __webpack_require__(127);
function injectStyle (ssrContext) {
  __webpack_require__(126)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Raycaster_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57860ca8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Raycaster_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlaneHelper_vue__ = __webpack_require__(30);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6625af82_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlaneHelper_vue__ = __webpack_require__(130);
function injectStyle (ssrContext) {
  __webpack_require__(129)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlaneHelper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6625af82_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlaneHelper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Object3D_vue__ = __webpack_require__(31);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c0e526d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Object3D_vue__ = __webpack_require__(133);
function injectStyle (ssrContext) {
  __webpack_require__(132)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Object3D_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c0e526d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Object3D_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"object-3d"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineStrip_vue__ = __webpack_require__(32);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ce4e444_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineStrip_vue__ = __webpack_require__(136);
function injectStyle (ssrContext) {
  __webpack_require__(135)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineStrip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ce4e444_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineStrip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineSegments_vue__ = __webpack_require__(33);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40e84994_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineSegments_vue__ = __webpack_require__(139);
function injectStyle (ssrContext) {
  __webpack_require__(138)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineSegments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40e84994_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineSegments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lineSegments"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mesh_vue__ = __webpack_require__(34);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35575b7a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mesh_vue__ = __webpack_require__(142);
function injectStyle (ssrContext) {
  __webpack_require__(141)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mesh_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35575b7a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mesh_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mesh"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Points_vue__ = __webpack_require__(35);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5919dcfb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Points_vue__ = __webpack_require__(145);
function injectStyle (ssrContext) {
  __webpack_require__(144)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Points_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5919dcfb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Points_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"points"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointLight_vue__ = __webpack_require__(36);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b2cc14a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointLight_vue__ = __webpack_require__(148);
function injectStyle (ssrContext) {
  __webpack_require__(147)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointLight_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b2cc14a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointLight_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"light-point"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpotLight_vue__ = __webpack_require__(37);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63badafd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpotLight_vue__ = __webpack_require__(151);
function injectStyle (ssrContext) {
  __webpack_require__(150)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpotLight_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63badafd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpotLight_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"light-point"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeshLambertMaterial_vue__ = __webpack_require__(38);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_175bf21a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeshLambertMaterial_vue__ = __webpack_require__(154);
function injectStyle (ssrContext) {
  __webpack_require__(153)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeshLambertMaterial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_175bf21a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeshLambertMaterial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mesh-lambert-material"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeshPhongMaterial_vue__ = __webpack_require__(39);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4596c706_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeshPhongMaterial_vue__ = __webpack_require__(157);
function injectStyle (ssrContext) {
  __webpack_require__(156)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeshPhongMaterial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4596c706_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeshPhongMaterial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mesh-phong-material"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineBasicMaterial_vue__ = __webpack_require__(40);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18c318e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineBasicMaterial_vue__ = __webpack_require__(160);
function injectStyle (ssrContext) {
  __webpack_require__(159)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineBasicMaterial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18c318e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineBasicMaterial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-basic-material"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShaderMaterial_vue__ = __webpack_require__(41);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65e4479e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShaderMaterial_vue__ = __webpack_require__(163);
function injectStyle (ssrContext) {
  __webpack_require__(162)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShaderMaterial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65e4479e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShaderMaterial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mesh-basic-material"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeshBasicMaterial_vue__ = __webpack_require__(42);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d546f36_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeshBasicMaterial_vue__ = __webpack_require__(166);
function injectStyle (ssrContext) {
  __webpack_require__(165)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeshBasicMaterial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d546f36_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeshBasicMaterial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mesh-basic-material"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointsMaterial_vue__ = __webpack_require__(43);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_193486ac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointsMaterial_vue__ = __webpack_require__(169);
function injectStyle (ssrContext) {
  __webpack_require__(168)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PointsMaterial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_193486ac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PointsMaterial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mesh-basic-material"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrawCountBufferGeometry_vue__ = __webpack_require__(44);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1892f60a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawCountBufferGeometry_vue__ = __webpack_require__(173);
function injectStyle (ssrContext) {
  __webpack_require__(171)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1892f60a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrawCountBufferGeometry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1892f60a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawCountBufferGeometry_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function() {
  return new Worker(__webpack_require__.p + "e1e6d98a22791755a0f4.worker.js");
};

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"geo-box"},[_c('iframe',{ref:'sandbox-frame',staticClass:"sandboxed",attrs:{"sandbox":"allow-same-origin allow-scripts"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleBufferGeometry_vue__ = __webpack_require__(45);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbcc06da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleBufferGeometry_vue__ = __webpack_require__(176);
function injectStyle (ssrContext) {
  __webpack_require__(175)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleBufferGeometry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbcc06da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleBufferGeometry_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"geo-circle"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TorusKnotBufferGeometry_vue__ = __webpack_require__(46);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a1ab6f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TorusKnotBufferGeometry_vue__ = __webpack_require__(179);
function injectStyle (ssrContext) {
  __webpack_require__(178)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TorusKnotBufferGeometry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a1ab6f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TorusKnotBufferGeometry_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"geo-TorusKnotBufferGeometry"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SphereBufferGeometry_vue__ = __webpack_require__(47);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77e6cc8a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SphereBufferGeometry_vue__ = __webpack_require__(182);
function injectStyle (ssrContext) {
  __webpack_require__(181)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SphereBufferGeometry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77e6cc8a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SphereBufferGeometry_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"geo-sphere"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BoxBufferGeometry_vue__ = __webpack_require__(48);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a59fca22_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BoxBufferGeometry_vue__ = __webpack_require__(185);
function injectStyle (ssrContext) {
  __webpack_require__(184)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BoxBufferGeometry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a59fca22_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BoxBufferGeometry_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"geo-box"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlaneBufferGeometry_vue__ = __webpack_require__(49);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73eee628_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlaneBufferGeometry_vue__ = __webpack_require__(188);
function injectStyle (ssrContext) {
  __webpack_require__(187)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlaneBufferGeometry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73eee628_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlaneBufferGeometry_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"geo-Plane"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"wrapper"},[(_vm.size)?_c('Renderer',{ref:"renderer",attrs:{"size":_vm.size},on:{"toucher":_vm.gotToucher,"renderer":function (v) { _vm.renderer = v }}}):_vm._e(),_vm._v(" "),(!_vm.noControl)?_c('div',{staticClass:"camera-control"},[_c('button',{on:{"click":function($event){_vm.lookAt('xy')}}},[_vm._v("XY")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.helper.xy),expression:"helper.xy"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.helper.xy)?_vm._i(_vm.helper.xy,null)>-1:(_vm.helper.xy)},on:{"change":function($event){var $$a=_vm.helper.xy,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.helper, "xy", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.helper, "xy", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.helper, "xy", $$c)}}}}),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.lookAt('xz')}}},[_vm._v("XZ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.helper.xz),expression:"helper.xz"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.helper.xz)?_vm._i(_vm.helper.xz,null)>-1:(_vm.helper.xz)},on:{"change":function($event){var $$a=_vm.helper.xz,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.helper, "xz", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.helper, "xz", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.helper, "xz", $$c)}}}}),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.lookAt('yz')}}},[_vm._v("YZ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.helper.yz),expression:"helper.yz"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.helper.yz)?_vm._i(_vm.helper.yz,null)>-1:(_vm.helper.yz)},on:{"change":function($event){var $$a=_vm.helper.yz,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.helper, "yz", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.helper, "yz", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.helper, "yz", $$c)}}}})]):_vm._e(),_vm._v(" "),_c('PerspectiveCamera',{attrs:{"fov":75,"aspect":_vm.size.aspect,"near":1,"far":1000,"position":_vm.camPos},on:{"camera":function (v) { _vm.camera = v },"refresh":function () { _vm.camera = _vm.v;  }}}),_vm._v(" "),_c('Scene',{on:{"scene":function (v) { _vm.scene = v }}},[(_vm.helper.yz)?_c('Object3D',{attrs:{"rz":_vm.PI / 2.0}},[_c('PlaneHelper',{attrs:{"colorAxis":'#000000',"colorGrid":'rgb(185,185,255)'}})],1):_vm._e(),_vm._v(" "),(_vm.helper.xz)?_c('Object3D',{attrs:{"ry":_vm.PI / 2.0}},[_c('PlaneHelper',{attrs:{"colorAxis":'#000000',"colorGrid":'rgb(185,255,185)'}})],1):_vm._e(),_vm._v(" "),(_vm.helper.xy)?_c('Object3D',{attrs:{"rx":_vm.PI / 2.0}},[_c('PlaneHelper',{attrs:{"colorAxis":'#000000',"colorGrid":'rgb(255,185,185)'}})],1):_vm._e(),_vm._v(" "),_c('Object3D',{attrs:{"pz":0}},_vm._l((_vm.plotters),function(plotter){return _c('LineStrip',{key:plotter.id},[_c('DrawCountBufferGeometry',{attrs:{"formula":plotter.formula,"step":plotter.stepper}}),_vm._v(" "),_c('LineBasicMaterial',{attrs:{"color":plotter.color}})],1)}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Editor_vue__ = __webpack_require__(50);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34dcbb41_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Editor_vue__ = __webpack_require__(203);
function injectStyle (ssrContext) {
  __webpack_require__(191)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34dcbb41"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34dcbb41_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ACE_vue__ = __webpack_require__(51);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cdb0412_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ACE_vue__ = __webpack_require__(202);
function injectStyle (ssrContext) {
  __webpack_require__(193)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ACE_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cdb0412_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ACE_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({height: _vm.height ? _vm.px(_vm.height) : '100%',width: _vm.width ? _vm.px(_vm.width) : '100%'})})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"plotter"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.current.color),expression:"current.color"}],attrs:{"type":"text"},domProps:{"value":(_vm.current.color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.current, "color", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.current.color),expression:"current.color"}],staticClass:"color",attrs:{"type":"color"},domProps:{"value":(_vm.current.color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.current, "color", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.current.stepper),expression:"current.stepper"}],attrs:{"type":"range","min":"0","max":"1.0","step":"0.00001"},domProps:{"value":(_vm.current.stepper)},on:{"__r":function($event){_vm.$set(_vm.current, "stepper", $event.target.value)}}}),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.cloneThis(_vm.current)}}},[_vm._v("Clone me")]),_vm._v(" "),_c('ACE',{attrs:{"path":_vm.current.id + '.js',"theme":"chrome","width":"100%","height":'500'},on:{"save":function () {
        },"input":function () { _vm.isDirty = true; }},model:{value:(_vm.current.formula),callback:function ($$v) {_vm.$set(_vm.current, "formula", $$v)},expression:"current.formula"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Editor2D_vue__ = __webpack_require__(55);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83f3b756_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Editor2D_vue__ = __webpack_require__(210);
function injectStyle (ssrContext) {
  __webpack_require__(205)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-83f3b756"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Editor2D_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83f3b756_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Editor2D_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */,
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoopItem_vue__ = __webpack_require__(57);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_620adc7c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoopItem_vue__ = __webpack_require__(209);
function injectStyle (ssrContext) {
  __webpack_require__(208)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-620adc7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoopItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_620adc7c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoopItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"parent",class:( _obj = {}, _obj[_vm.model.type] = _vm.model.type === 'repeat', _obj )},[_c('div',{class:{ bold: _vm.isFolder },attrs:{"dblclick":"changeType"},on:{"click":_vm.toggle}},[(_vm.model.type === 'repeat')?_c('span',[_vm._v(_vm._s(_vm.model.type)+" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.data.times),expression:"model.data.times"}],staticClass:"num",attrs:{"type":"text"},domProps:{"value":(_vm.model.data.times)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.data, "times", $event.target.value)}}})]):(_vm.model.type === 'mover2D.moveBy')?_c('span',[_vm._v(_vm._s(_vm.model.type)+" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.data.amount),expression:"model.data.amount"}],staticClass:"num",attrs:{"type":"text"},domProps:{"value":(_vm.model.data.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.data, "amount", $event.target.value)}}})]):(_vm.model.type === 'mover2D.turnBy')?_c('span',[_vm._v(_vm._s(_vm.model.type)+" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.data.amount),expression:"model.data.amount"}],staticClass:"num",attrs:{"type":"text"},domProps:{"value":(_vm.model.data.amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.data, "amount", $event.target.value)}}})]):(_vm.model.type === 'mover2D.usePlane')?_c('span',[_vm._v("\n      "+_vm._s(_vm.model.type)+"\n      "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.data.usePlane),expression:"model.data.usePlane"}],staticClass:"selector",attrs:{"type":"text"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model.data, "usePlane", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"xy"}},[_vm._v("xy")]),_vm._v(" "),_c('option',{attrs:{"value":"xz"}},[_vm._v("xz")]),_vm._v(" "),_c('option',{attrs:{"value":"yz"}},[_vm._v("yz")])])]):(_vm.model.type === 'variable')?_c('span',[_vm._v("\n      "+_vm._s(_vm.model.type)+"\n      "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.data.name),expression:"model.data.name"}],staticClass:"selector",attrs:{"type":"text"},domProps:{"value":(_vm.model.data.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.data, "name", $event.target.value)}}}),_vm._v("\n      start at\n      "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.data.init),expression:"model.data.init"}],staticClass:"num",attrs:{"type":"text"},domProps:{"value":(_vm.model.data.init)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.data, "init", $event.target.value)}}})]):(_vm.model.type === 'update')?_c('span',[_vm._v("\n      "+_vm._s(_vm.model.type)+"\n      "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.data.name),expression:"model.data.name"}],staticClass:"selector",attrs:{"type":"text"},domProps:{"value":(_vm.model.data.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.data, "name", $event.target.value)}}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.data.modification),expression:"model.data.modification"}],staticClass:"selector",attrs:{"type":"text"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model.data, "modification", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"add-by"}},[_vm._v("add")]),_vm._v(" "),_c('option',{attrs:{"value":"subtract-by"}},[_vm._v("subtract")]),_vm._v(" "),_c('option',{attrs:{"value":"multiply-by"}},[_vm._v("multiply")]),_vm._v(" "),_c('option',{attrs:{"value":"divided-by"}},[_vm._v("divided by")]),_vm._v(" "),_c('option',{attrs:{"value":"set-to"}},[_vm._v("set to")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.data.value),expression:"model.data.value"}],staticClass:"num",attrs:{"type":"text"},domProps:{"value":(_vm.model.data.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model.data, "value", $event.target.value)}}})]):(_vm.mode === 'bin' && _vm.$parent.mode !== 'bin')?_c('span',[_vm._v(_vm._s(_vm.model.type)+" "),_c('button',{staticClass:"empty",on:{"click":_vm.emptyTrash}},[_vm._v("Empty Trash")])]):_c('span',[_vm._v(_vm._s(_vm.model.type)+" ")])]),_vm._v(" "),(_vm.isFolder)?_c('draggable',{attrs:{"element":'ol',"options":{ group: { name: 'code', pull: _vm.model.pull, put: _vm.model.put }, filter: '.ignore' },"clone":_vm.cloner,"dshow":"open"},model:{value:(_vm.model.children),callback:function ($$v) {_vm.$set(_vm.model, "children", $$v)},expression:"model.children"}},[_vm._l((_vm.model.children),function(mm){return _c('LoopItem',{key:mm.id,staticClass:"item",attrs:{"model":mm}})}),_vm._v(" "),(_vm.model.children && _vm.model.children.length === 0)?_c('div',{staticClass:"add ignore"},[_vm._v("drop here")]):_vm._e()],2):_vm._e()],1)
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor-2D"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.current.color),expression:"current.color"}],attrs:{"type":"text"},domProps:{"value":(_vm.current.color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.current, "color", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.current.color),expression:"current.color"}],staticClass:"color",attrs:{"type":"color"},domProps:{"value":(_vm.current.color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.current, "color", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.current.stepper),expression:"current.stepper"}],attrs:{"type":"range","min":"0","max":"1.0","step":"0.00001"},domProps:{"value":(_vm.current.stepper)},on:{"__r":function($event){_vm.$set(_vm.current, "stepper", $event.target.value)}}}),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.$emit('clone', _vm.current)}}},[_vm._v("Clone me")]),_vm._v(" "),_c('div',{staticClass:"horizontal"},[(_vm.tools)?_c('ul',[_c('LoopItem',{staticClass:"item",attrs:{"model":_vm.tools}})],1):_vm._e(),_vm._v(" "),_c('div',[(_vm.current && _vm.current.blockers && _vm.current.blockers.bin)?_c('ul',[_c('LoopItem',{staticClass:"item",attrs:{"mode":'bin',"model":_vm.current.blockers.bin}})],1):_vm._e(),_vm._v(" "),(_vm.current && _vm.current.blockers && _vm.current.blockers.tree)?_c('ul',[_c('LoopItem',{staticClass:"item",attrs:{"model":_vm.current.blockers.tree}})],1):_vm._e()])]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.coder.getCode(_vm.current.blockers.tree, _vm.current.blockers.tree.id)))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full"},[_c('Viewer',{staticClass:"viewer",attrs:{"plotters":_vm.plotters}}),_vm._v(" "),_c('div',{staticClass:"editor"},[_c('div',{staticClass:"viewer-list"},_vm._l((_vm.plotters),function(plot){return _c('Viewer',{key:plot.id,staticClass:"viewer-item",class:{ 'marker': _vm.current === plot, 'no-marker': _vm.current !== plot },attrs:{"noControl":true,"plotters":[plot]},on:{"click":function($event){_vm.current = plot}}})})),_vm._v(" "),(_vm.current && _vm.current.type === 'code')?_c('Editor',{attrs:{"current":_vm.current,"plotters":_vm.plotters},on:{"clone":_vm.cloneMe}}):_vm._e(),_vm._v(" "),(_vm.current && _vm.current.type === 'blockers')?_c('Editor2D',{attrs:{"current":_vm.current},on:{"clone":_vm.cloneMe}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('OMD3',{staticClass:"hello"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[59]);


// WEBPACK FOOTER //
// static/js/app.874fd14a3e4f24917fc9.js